import React from "react";
import { CssBaseline, Container } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { useLocation } from "react-router-dom";
import { isAuthenticated } from "./utils/auth";
import LoginPage from "./pages/LoginPage";
import FancyAppBar, { APP_BAR_HEIGHT } from "./components/FancyAppBar"; // Import from new file

const App: React.FC = () => {
    const location = useLocation();
    const showAppBar = isAuthenticated() && location.pathname !== "/login";
    const isLoginPage = location.pathname === "/login";

    return (
        <>
            <CssBaseline />
            {showAppBar && <FancyAppBar />}
            {isLoginPage ? (
                <LoginPage />
            ) : (
                <Container
                    maxWidth={false}
                    disableGutters
                    sx={{
                        mt: `${APP_BAR_HEIGHT}px`,
                        mx: "auto",
                        px: 4,
                        pb: 4,
                        width: '100%',
                    }}
                >
                    <AppRoutes />
                </Container>
            )}
        </>
    );
};

export default App;
